

export default [
    {
        icon: 'mdi-github',
        color: 'dark',
        href: 'https://github.com/robsmitha',
        text: 'GitHub'
    },
    {
        icon: 'mdi-linkedin',
        color: 'blue',
        href: 'https://www.linkedin.com/in/robsmitha/',
        text: 'LinkedIn'
    },
    {
        icon: 'mdi-file-account',
        color: 'red',
        href: 'https://smitha-cdn.s3.us-east-2.amazonaws.com/Content/files/Rob+Smitha+Resume.pdf',
        text: 'Résumé'
    }
]